import React from "react";

const MILESTONES = [
  {
    year: "2026",
    title: "Four hives, one hillside",
    body: "BeeLuxe starts on a family plot in the Blue Ridge foothills with four hand-built hives.",
  },
  {
    year: "2028",
    title: "First wholesale jar",
    body: "A single wildflower batch reaches its first restaurant partner, unblended and unfiltered.",
  },
  {
    year: "2031",
    title: "Four apiaries",
    body: "Three more family apiaries join, each keeping its own flavor instead of merging into one blend.",
  },
];

export default function OurStory() {
  return (
    <div className="page">
      <div className="eyebrow" style={{ textAlign: "center" }}>
        SINCE 1990
      </div>
      <div className="section-title">Our Story</div>
      <p className="section-sub">
        BeeLuxe began with a simple belief: honey deserves the same care as fine
        wine — patient harvesting, honest bottling, and nothing added to hurry
        it along.
      </p>
      <div className="cards">
        {MILESTONES.map((m) => (
          <article className="card" key={m.year}>
            <div
              className="icon"
              style={{ fontFamily: "Cinzel, serif", fontSize: 26 }}
            >
              {m.year}
            </div>
            <h3>{m.title}</h3>
            <p>{m.body}</p>
          </article>
        ))}
      </div>
    </div>
  );
}
